import { HttpForm } from "../Support/HttpForm";
import { axios } from "../Support/Axios";
export class Settings extends HttpForm {
    data = {
        name: '',
        email: '',
        marketing: true,
        new_password: null,
        new_password_confirmation: null,
        two_factor: {
            enabled: false,
            confirmed: null,
        }
    };
    mfa_loading = false;
    show_recovery_codes = false;
    mount() {
        return this.get()
            .then((response) => {
            this.data = response.data.data;
            this.setLoadingState(true);
        })
            .catch(e => this.setError(e));
    }
    get() {
        const url = '/api/user/settings?' + 'src=' + this.show_recovery_codes;
        return axios.get(url).catch(e => this.setError(e));
    }
    update() {
        const url = '/api/user/settings';
        this.setupFormSubmission();
        return axios.patch(url, this.data)
            .then(() => this.setSuccessMessage('Account settings updated.'))
            .catch(e => this.setError(e));
    }
    delete() {
        const url = '/api/user';
        return axios.delete(url)
            .then(() => window.location.href = 'login')
            .catch(e => this.setError(e));
    }
    refreshUserSettings() {
        this.show_recovery_codes = true;
        return this.get().then((response) => {
            this.data = response.data.data;
        }).catch(e => this.setError(e));
    }
    enableTwoFactorAuthentication() {
        const url = '/user/two-factor-authentication';
        this.toggleTwoFactorLoading();
        return axios.post(url)
            .then((response) => {
            this.refreshUserSettings().then(() => this.toggleTwoFactorLoading());
        })
            .catch(e => {
            this.setError(e);
            this.toggleTwoFactorLoading();
        });
    }
    disableTwoFactorAuthentication() {
        const url = '/user/two-factor-authentication';
        this.toggleTwoFactorLoading();
        return axios.delete(url)
            .then((response) => {
            this.refreshUserSettings().then(() => this.toggleTwoFactorLoading());
        })
            .catch(e => {
            this.setError(e);
            this.toggleTwoFactorLoading();
        });
    }
    checkTwoFactorAuthentication() {
        const url = '/api/user/check-two-factor';
        this.resetFormMessages().then(() => {
            this.toggleTwoFactorLoading();
        });
        axios.post(url, {
            code: this.data.code
        }).then((response) => {
            this.refreshUserSettings().then(() => this.toggleTwoFactorLoading());
        })
            .catch(e => {
            this.toggleTwoFactorLoading();
            this.setError(e);
        });
    }
    regenerateRecoveryCodes() {
        const url = '/user/two-factor-recovery-codes ';
        this.resetFormMessages().then(() => {
            this.toggleTwoFactorLoading();
        });
        axios.post(url).then((response) => {
            this.refreshUserSettings().then(() => this.toggleTwoFactorLoading());
        }).catch(e => {
            this.setError(e);
            this.toggleTwoFactorLoading();
        });
    }
    hideRecoveryCodes() {
        this.show_recovery_codes = false;
    }
    toggleTwoFactorLoading() {
        this.mfa_loading = !this.mfa_loading;
    }
}
